export default __webpack_public_path__ + "resources/ProximaVaraVariable.7f2ad426b378f824f2f0cb8c7b71c01d.woff2";